import React from 'react'
import '../../App.css'
function Loader() {
  return (
    <div className="min-h-[calc(100vh-3.79rem)] w-screen text-3xl text-white flex items-center justify-center">
      <div className='loader'></div>
    </div>
  )
}

export default Loader